module.exports = __webpack_public_path__ + "static/media/hugo_desktop_1.0f8942eb.png";